<template>
  <v-page>
    <v-form v-model="valid" @submit.prevent="login()" ref="form">
      <!-- TODO: Elabs Logo -->
      <v-card-title primary-title class="pb-4">
        <img src="~@/assets/img/logo.png" alt />
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field
          prepend-icon="fa-user"
          name="username"
          label="Username"
          type="text"
          :rules="[v => !!v || 'Username is required']"
          v-model="username"
          required
        ></v-text-field>

        <v-text-field
          prepend-icon="fa-lock"
          id="password"
          name="password"
          type="password"
          label="Password"
          :rules="[v => !!v || 'Password is required']"
          v-model="password"
          required
        ></v-text-field>

        <div class="text-xs-left body-2 mt-3 ml-2 pd-0">
          <a @click="openForgotPassword">Forgot your password?</a>
        </div>

        <!-- <div class="text-xs-left body-2 mt-3">
          <span style="color:#F44336">
            IMPORTANT:
            </span> This app runs properly in Chrome browser only.
            <a href="https://www.google.com/chrome/" target="_blank">Download Chrome <i class="fab fa-chrome"></i></a>
        </div>-->
      </v-card-text>
      <forgotPassword ref="forgotPassword"></forgotPassword>

      <v-card-actions style="padding:0px">
        <!-- <v-flex xs8 offset-xs1 v-if="submitted">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>-->

        <v-card-title style="padding-bottom: 0px; max-height: 80px;">
          <div>
            <span class="display-3">{{ appName }}</span>
            <span class="subheading ml-2">{{ appVersion }}</span>
          </div>
        </v-card-title>

        <v-spacer></v-spacer>
        <v-card-title style="padding-bottom: 0px; padding-top: 40px;">
          <v-btn type="submit" color="primary">Login</v-btn>
        </v-card-title>
      </v-card-actions>
      <v-card-text style="padding-top: 0px;">
        <v-layout row>
          <v-flex class="ml-1" style="font-size: 12.8px">BILLING &amp; OPERATION SUPPORT SYSTEM</v-flex>
          <!-- <span v-if="submitted">
            <v-progress-linear v-if="submitted" :indeterminate="true"></v-progress-linear>
          </span>-->
          <v-flex v-if="submitted" style="max-height: 19px; margin-top: -7.55px; width: 300px">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-form>
    <password-expiry-banner ref="passwordExpiryBanner"></password-expiry-banner>
  </v-page>
</template>

<script>
import VPage from "../layouts/Minimal.vue";
import Bus from "../bus";
import { App } from "../config.js";
import forgotPassword from "./ForgotPassword.vue";
import axios from "axios";
import passwordExpiryBanner from "../components/PasswordExpiryBanner.vue";

export default {
  name: "Login",
  components: {
    VPage,
    forgotPassword,
    passwordExpiryBanner
  },
  data() {
    return {
      appName: App.name,
      appVersion: App.version,
      error: "",
      valid: false,
      username: "",
      password: "",
      submitted: false
    };
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.submitted = true;
        const username = this.username;
        const password = this.password;

        this.$store
          .dispatch("auth/login", { username, password })
          .then(async token => {
            this.submitted = false;
            // direct to last saved
            axios
              .get("/api/User/GetLastPage/")
              .then(res => {
                var userProfile = res.data;
                if (userProfile.LastPage) {
                  this.$router.push({ path: userProfile.LastPage });
                } else this.$router.push("/");
              })
              .catch(error => {
                this.$router.push("/");
              });
            // this.$router.push("/");
            Bus.$emit("alert", {
              color: "success",
              message: "Login Successful!"
            });
            //shows password Expiry Banner if password expires under 7 days
            this.$refs.passwordExpiryBanner.open;
          })
          .catch(err => {
            this.submitted = false;
            // alert("Login Failed!");
            Bus.$emit("alert", { color: "error", message: "Login Failed!" });
          });
      }
    },
    openForgotPassword() {
      this.$refs.forgotPassword.open();
    }
  }
};
</script>
